import { render } from "./ImagePerson.vue?vue&type=template&id=58e384d6"
import script from "./ImagePerson.vue?vue&type=script&lang=js"
export * from "./ImagePerson.vue?vue&type=script&lang=js"

import exportComponent from "F:\\Project Coustomer\\vue film\\film\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__